<div>
  <header
      class="accent"
      fxLayout="row"
      fxLayoutAlign="space-between center"
  >
    <div class="title">Gestão de Relacionamento</div>
    <div fxLayout="row">      
    </div>
  </header>

  <div fxLayout="row">
    <div fxFlex="5" fxLayout="column" fxLayoutAlign="center">
      <div fxLayout="row" fxLayoutAlign="center">
        <button mat-icon-button class="timeline-button" (click)="paginate(-1)">
            <mat-icon style="font-size: 42px;">arrow_left</mat-icon>
        </button>
      </div>
    </div>
    
    <!-- <ngx-htl-horizontal-timeline 
        fxFlex="90" 
        class="prosper-timeline" 
        [(items)]="items">
    </ngx-htl-horizontal-timeline> -->
   
    <div fxFlex="5" fxLayout="column" fxLayoutAlign="center">
      <div fxLayout="row" fxLayoutAlign="center">
        <button mat-icon-button class="timeline-button" (click)="paginate(1)">
            <mat-icon style="font-size: 42px;">arrow_right</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
